import { useState } from 'react'
import { useJoinRoom } from '@vatom/sdk/react'
import { translate } from '@vatom/utils'
import { Button, Text, theme } from '@vatom/wombo'
import { Box, Input } from 'native-base'

import Alert from '../../../components/Alert'

export const AddSpace = () => {
  const [value, setValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const joinRoomMutation = useJoinRoom()

  const joinSpace = async () => {
    setIsLoading(true)
    try {
      const res = await joinRoomMutation.mutateAsync(value)
      if (res) {
        setValue('')
      }
    } catch (error) {
      Alert.showError(error)
    }
    setIsLoading(false)
  }

  return (
    <Box
      mb="8px"
      px="16px"
      h="40px"
      _dark={{
        backgroundColor: theme.colors.grayCool[900]
      }}
      _light={{
        backgroundColor: theme.colors.white
      }}
      w="100%"
      alignItems="center"
      flexDir={'row'}
    >
      <Input
        isDisabled={isLoading}
        autoCapitalize="none"
        placeholder={translate('spaceScreen.spaceAlias')}
        value={value}
        onChangeText={setValue}
        w="80%"
        borderColor="grayCool.300"
        borderWidth={1}
        mr="4px"
        fontSize={15}
        fontWeight={600}
        letterSpacing={0}
        _dark={{
          focusOutlineColor: theme.colors.systemColorsDark.orange
        }}
        leftElement={
          <Box
            borderRightWidth={1}
            h="100%"
            borderColor="grayCool.400"
            p={2}
            justifyContent="center"
          >
            <Text fontSize={15} fontWeight={600} letterSpacing={0} color="grayCool.600">
              @
            </Text>
          </Box>
        }
      />

      <Button w="20%" isDisabled={isLoading || !value} bgColor="grayCool.200" onPress={joinSpace}>
        <Text fontWeight={500} fontSize={13} lineHeight={18} letterSpacing={0} color="grayCool">
          {isLoading ? 'Joining' : 'Join'}
        </Text>
      </Button>
    </Box>
  )
}
